"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Radio: true
};
exports.default = exports.Radio = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Radio = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Radio.css") : void 0);
var _Radio2 = require("./Radio.types");
Object.keys(_Radio2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Radio2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Radio2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-radio';
const Radio = exports.Radio = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Radio, _props)) : _props;
  const {
      ariaLabel,
      children,
      checked,
      className,
      disabled,
      labelClassName,
      labelProps,
      inputRef,
      onChange,
      isControlled,
      state,
      readOnly
    } = props,
    otherProps = __rest(props, ["ariaLabel", "children", "checked", "className", "disabled", "labelClassName", "labelProps", "inputRef", "onChange", "isControlled", "state", "readOnly"]);
  const classnames = _bind.default.bind(_Radio.default);
  const classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, labelClassName, {
    [`${CSS_BLOCK}--disabled`]: disabled
  });
  const inputClasses = classnames(_constants.CSS_PREFIX, [`${CSS_BLOCK}__input`], {
    [`${CSS_BLOCK}__input--${state}`]: state,
    [`${CSS_BLOCK}__input--readonly`]: !!readOnly,
    [`${CSS_BLOCK}__input--disabled`]: !!disabled
  }, className);
  const input = /*#__PURE__*/_react.default.createElement("input", Object.assign({}, otherProps, {
    "aria-label": ariaLabel,
    "aria-disabled": disabled || readOnly,
    checked: isControlled ? !!checked : checked,
    className: inputClasses,
    disabled: disabled || readOnly,
    onChange: onChange,
    ref: inputRef,
    type: "radio"
  }));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react.default.createElement("label", Object.assign({}, labelProps, {
      className: classes,
      ref: ref
    }), input, children && (/*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__label`)
    }, children)))
  );
});
Radio.displayName = 'Radio';
var _default = exports.default = Radio;